/* eslint-disable no-unused-vars */
export enum AssignmentStatus {
  PrefixLitigationStatus = 'litigationStatus:',
  Deprecated = PrefixLitigationStatus + 'deprecated',
  Duplicated = PrefixLitigationStatus + 'duplicated',
  PendingAssignment = PrefixLitigationStatus + 'pendingAssignment',
  ProcessedWithError = PrefixLitigationStatus + 'processedWithError',
  ExportedWithError = PrefixLitigationStatus + 'exportedWithError',
  NoResponsibleEntity = PrefixLitigationStatus + 'noResponsibleEntity',
  Assigned = PrefixLitigationStatus + 'assigned',
  Exported = PrefixLitigationStatus + 'exported',
  NotToBeAssigned = PrefixLitigationStatus + 'notToBeAssigned',
}
